import { create } from 'zustand';

interface PrescriptionModalState {
  openPrescriptionModal: boolean;
  setOpenPrescriptionModal: (open: boolean) => void;
}

export const usePrescriptionModalStore = create<PrescriptionModalState>((set) => ({
  openPrescriptionModal: false,
  setOpenPrescriptionModal: (openPrescriptionModal: boolean) => set({ openPrescriptionModal }),
})); 